module.exports = __webpack_public_path__ + "static/media/img_solution_two.5a9477b3.png";